import useMutationHookWrapper, {TAsyncStatesHandlers} from "../../../../../hooks/use-mutation-hook-wrapper";
import {network} from "../../../../../types";
import {serviceScreenings} from "../../../../../services";

const useScreeningCreatePost = (
  arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
  return useMutationHookWrapper<
    network.TQueryDefWrapper<null>,
    string,
    { adminId: string }
  >({
    mutationFn: serviceScreenings.createScreeningJob,
    asyncStateHandlers: arg0,
  });
};

export default useScreeningCreatePost;
